import { render, staticRenderFns } from "./ProductDetailLoader.vue?vue&type=template&id=2ea4eb9c&scoped=true&"
import script from "./ProductDetailLoader.vue?vue&type=script&lang=js&"
export * from "./ProductDetailLoader.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailLoader.vue?vue&type=style&index=0&id=2ea4eb9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea4eb9c",
  null
  
)

export default component.exports